import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/renovacionRegistroSanitario';
import ListRegistros from './RenovacionRegistroList';


const ms2p = (state) => {
  return {
    ...state.rs_renovacion_registro_sanitario,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListRegistros);
